export default (initialData = {}) => ({
    isEditing: false,
    processing: false,
    form: { ...initialData },
    originalForm: { ...initialData },
    errors: {},
    successMessage: '',

    routes: { update: '' },
    csrfToken: '',

    get csrfHeader() {
        return (
            document.querySelector('meta[name=csrf-token]')?.content ??
            this.csrfToken
        );
    },

    clearMessages() {
        this.errors = {};
        this.successMessage = '';
    },

    hasError(field) {
        return this.errors[field]?.length > 0;
    },

    getError(field) {
        return this.errors[field]?.[0] ?? '';
    },

    async submit() {
        if (this.processing) return;

        const formData = { ...this.form };

        this.processing = true;
        this.clearMessages();

        try {
            const res = await fetch(this.routes.update, {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    'X-CSRF-TOKEN': this.csrfHeader,
                },
                body: JSON.stringify(formData),
            });

            const data = await res.json();

            if (res.status === 422) {
                this.errors = data.errors ?? {};
                return;
            }

            if (!res.ok) {
                this.errors = {
                    _general: [data.message ?? 'Произошла ошибка'],
                };
                return;
            }

            // Обновляем данные из ответа сервера
            if (data.user) {
                this.form = {
                    name: data.user.name ?? '',
                    email: data.user.email ?? '',
                    phone: data.user.phone ?? '',
                };
                this.originalForm = { ...this.form };
            } else {
                this.originalForm = { ...this.form };
            }

            this.successMessage = data.message ?? 'Сохранено';
            this.isEditing = false;

            setTimeout(() => (this.successMessage = ''), 3000);
        } catch (e) {
            console.error('Submit error:', e);
            this.errors = { _general: ['Ошибка сети. Попробуйте ещё раз.'] };
        } finally {
            this.processing = false;
        }
    },

    cancel() {
        this.isEditing = false;
        this.form = { ...this.originalForm };
        this.clearMessages();
    },
});
